import React, { useEffect } from "react";

export default function Toast({ message, type = "success", onClose }) {
  useEffect(() => {
    const t = setTimeout(onClose, 3000);
    return () => clearTimeout(t);
  }, [onClose]);

  const colors = {
    success: "bg-green-600",
    error:   "bg-red-600",
    info:    "bg-blue-600",
  };

  return (
    <div className="fixed top-4 left-1/2 z-50 w-full max-w-[430px] -translate-x-1/2 px-5">
      <div className={`${colors[type]} text-white text-sm font-medium px-4 py-3 rounded-xl shadow-xl
        animate-fade-up flex items-start gap-2`}
      >
        {type === "success" && <span className="shrink-0">✓</span>}
        {type === "error"   && <span className="shrink-0">⚠</span>}
        <span className="min-w-0 flex-1 break-words">{message}</span>
        <button
          type="button"
          onClick={onClose}
          aria-label="Tutup notifikasi"
          className="shrink-0 -m-1 p-1 leading-none opacity-80 hover:opacity-100"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
